import React, { useState } from 'react'
import AutoComplete from '../Common/AutoComplete'
import ModalLayout from '../Modals/ModalLayout';
import TaskModal from '../Modals/TaskModal';
import LeadReplies from '../Modals/LeadReplies';
import ModalLayoutNew from '../Modals/ModalLayoutNew';

const CiqHeader = ({ handleNewAppraisal, title, location }) => {


    const [taskCount, setTaskCount] = useState(0);
    const [replyCount, setReplyCount] = useState(0);
    // Tasks Modal
    const [taskModal, setTaskModal] = useState(false);
    const handleTasksOpen = () => {
        setTaskModal(true);
        document.body.classList.add('overflow-body');
        
    }
    const handleTasksClose = () => {
        setTaskModal(false);
        document.body.classList.remove('overflow-body');
    }
    // Replies Modal
    const [repliesModal, setRepliesModal] = useState(false);
    const repliesModalOpen = (value) => {
        setRepliesModal(value);
    }
    return (
        <>
            <div className='d-lg-flex align-items-center justify-content-between ciq-tb-header'>
                <div className='d-flex align-items-center justify-content-between mb-md-4 mb-3'>
                    <div className='md-title text-uppercase font-26 text-lgray'>{title}</div>
                    {/* <div className='d-lg-none ss-menu'>{title}</div> */}
                </div>
                <div className='d-flex align-items-center mb-md-4 mb-3 justify-content-between ciq-ca-'>
                    {title === 'CallBack Clients' &&
                        <>
                            <div>
                                <button type="button" onClick={() => { repliesModalOpen(true) }} className='transparent-btn callback-trans-btn yellow-border d-inline-block me-3 text-uppercase'>
                                    <span className='exclamation-icon'><i className="fa-solid fa-triangle-exclamation"></i></span> Un-Answered <span className='count ms-2'>{replyCount}</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" onClick={handleTasksOpen} className='transparent-btn callback-trans-btn me-3 d-inline-block'>
                                    <span className='setting-icon'></span> TASKS <span className='count ms-2'>{taskCount}</span>
                                </button>
                            </div>
                        </>
                    }
                    <div className='order-lg-2 w-50 pe-2 pe-lg-0'><AutoComplete ciqheader={true} inPerson={true} /></div>
                    <div className='w-50 ps-2 ps-lg-0'>
                        <button className='blue-btn mnw-170 text-start' type='button' onClick={handleNewAppraisal}>
                            <span className='upload-icon me-3'></span> New Appraisal
                        </button>
                    </div>
                </div>
            </div>
            <ModalLayoutNew open={taskModal} close={handleTasksClose} darkThemeCls='true' modalWidth={990}>
                <TaskModal close={handleTasksClose} setTaskCount={setTaskCount} inStore={true} location={location}/>
            </ModalLayoutNew>
            <ModalLayout open={repliesModal} close={() => { repliesModalOpen(false) }}>
                <LeadReplies close={() => { repliesModalOpen(false) }} setReplyCount={setReplyCount} inStore={true} location={location} />
            </ModalLayout>
        </>
    )
}

export default CiqHeader